import React from "react";
import clsx from "clsx";
import Button from "../../../../../shared-components/css-modules/toyota/atoms/Button";
import styles from "./Cta.module.scss";
import { useCarConfigSelector } from "../../../../redux/store";
import { useCarConfigOptionalLabel } from "../../../../utils/labelUtils";
import CtaButton from "../cta/CtaButton";
import FinanceWrapper from "./FinanceWrapper";
import { useAphFooterOffset } from "../../../../hooks/useAphFooterOffset";
import { useAphBreakpoint } from "../../../../../shared-logic/hooks/useBreakpoint";
import { ctaConfigSelector } from "../../../../utils/selectorUtils";
import CtaDisclaimer from "./CtaDisclaimer";
import { CarConfigConfigureSection } from "../../../../utils/types/SectionTypes";
import { useAphNavigation } from "../../../../hooks/useAphNavigation";
import { CarConfigStep } from "../../../../../../../common-deprecated/features/apheleia/utils/carConfigNavigationUtils";
import { BUTTON_SUMMARY } from "../../../../utils/dataTestIDs";

const Cta: React.FC = () => {
    const ref = React.useRef<HTMLDivElement>(null);
    const isMobile = useAphBreakpoint("down", "xl");
    const financeOption = useCarConfigSelector((state) => state.utils.financeOption);
    const navigationCtas = useCarConfigSelector((state) => ctaConfigSelector(state, "navigationCtas", isMobile));
    const handleClick = useAphNavigation();

    const isCashSelected = financeOption === "cash";

    const [carConfigBuyFor, carConfigSelectFor] = useCarConfigOptionalLabel(["carConfigBuyFor", "carConfigSelectFor"]);

    useAphFooterOffset(ref);

    return (
        <div className={clsx(styles.cta)} ref={ref}>
            <FinanceWrapper />

            {/* Go to buy buttons */}
            <div className={styles.buttons}>
                <Button
                    variant="btn-default"
                    className={styles["btn-mobile"]}
                    href={`#${CarConfigConfigureSection.SummaryDetails}`}
                    onClick={handleClick(CarConfigStep.Configure, CarConfigConfigureSection.SummaryDetails, "start")}
                >
                    {isCashSelected ? carConfigBuyFor : carConfigSelectFor}
                </Button>
                <div className={styles.ctas}>
                    {navigationCtas &&
                        navigationCtas?.length > 0 &&
                        navigationCtas
                            // Limit secondary cta to 1 for now, this functionality should be at AEM side
                            ?.slice(0, 1)
                            .map((cta) => <CtaButton ctaConfig={cta} key={`${cta.type as string}-${cta.title}`} />)}
                </div>
                <Button
                    data-testid={BUTTON_SUMMARY}
                    variant="btn-default"
                    className={`${styles["btn-desktop"]} ${styles["btn-span-pointers-disabled"]}`}
                    onClick={handleClick(CarConfigStep.Configure, CarConfigConfigureSection.SummaryDetails, "start")}
                >
                    {isCashSelected ? carConfigBuyFor : carConfigSelectFor}
                </Button>
            </div>

            <CtaDisclaimer />
        </div>
    );
};

export default Cta;
